<template>
  <el-row class="search-categories container">
    <el-button
      v-for="(itemCategory, index) in categories"
      :key="itemCategory.key || index"
      class="category-buttons"
      search-button
      :class="{
        active : category && category.key === itemCategory.key,
        inactive : category && category.key !== itemCategory.key,
      }"
      :icon="'icon-'+itemCategory.key"
      @click="selectCategory(itemCategory)"
    >
      {{ itemCategory.key ? $t('category.' + itemCategory.key) : ' ' }}
    </el-button>
    <el-col
      v-if="category && category.subcategories && category.subcategories.length && !isMobile"
      class="subcategories"
    >
      <el-button
        v-for="itemSubcategory in category.subcategories"
        :key="itemSubcategory.key"
        :class="{
          'subcategory-button': true,
          active : subcategory && subcategory.key === itemSubcategory.key,
          inactive : !subcategory || subcategory.key !== itemSubcategory.key,
        }"
        @click="selectSubcategory(itemSubcategory)"
      >
        {{ $t('subcategory.' + category.key + '.' + itemSubcategory.key) }}
        <i :class="'icon-'+itemSubcategory.key" />
      </el-button>
      <router-link
        :to="{ name: 'Search' }"
        tag="el-button"
        class="see-all subcategory-button"
      >
        {{ $t('filter.see-all.label') }}
        <i class="el-input__icon el-icon-arrow-up" />
      </router-link>
    </el-col>
  </el-row>
</template>

<script>

import { mapState } from 'vuex';

export default {
  name: 'SearchCategories',
  computed: {
    ...mapState({
      category: state => state.filters.category,
      subcategory: state => state.filters.subcategory,
      isMobile: state => state.isMobile,
      categories: state => state.temp.categories.list,
    }),
  },
  methods: {
    selectCategory(category) {
      this.$store.dispatch('setCategory', category !== this.category ? category : null);
    },
    selectSubcategory(subcategory) {
      this.$store.dispatch('setSubcategory', subcategory !== this.subcategory ? subcategory : null);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SearchCategories.vue